var regExpPropType = function (props, propName, componentName, location) {
  if (!(props[propName] instanceof RegExp)) {
    var propType = typeof props[propName];

    return new Error(
      ("Invalid " + location + " `" + propName + "` of type `" + propType + "` ") +
        ("supplied to `" + componentName + "`, expected `RegExp`.")
    );
  }
};

module.exports = regExpPropType;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-highlighter/lib/regExpPropType.js
 ** module id = 1637
 ** module chunks = 0
 **/